import { createAsyncThunk } from '@reduxjs/toolkit';
import instance from '../../axiosInstance';
import Agent from '../../interfaces/agent';
import { deserializeData } from '../../utils/deserializer';
import {
  AgentLiveTransferRequest,
  AgentLiveTransferRequestDisposition,
} from './types';

/// /
// Async Thunk Actions
/// /
export const fetchAgentById = createAsyncThunk<Agent, string | number>(
  'agents/fetchAgentById',
  async (agentId) => {
    const response = await instance.get(`/deals/agent/${agentId}/`);
    return response.data;
  },
);

export const patchAgent = createAsyncThunk<Agent, any>(
  'agents/patchAgent',
  async (agent) => {
    const agentId = agent.id;
    const { data } = agent;
    const response = await instance.patch(`/deals/agent/${agentId}/`, {
      ...data,
    });
    return response.data;
  },
);

export const fetchAgentLiveTransferRequestsByDealId = createAsyncThunk<
  AgentLiveTransferRequest[],
  { dealId: string }
>('agents/fetchAgentLiveTransferRequestsByDealId', async ({ dealId }) => {
  const response = await instance.get(
    `v4/agent-live-transfer/requests/?filter[deal]=${dealId}&page[size]=100`,
  );

  const data = deserializeData<AgentLiveTransferRequest[]>(response.data);

  if (!data || !data.length) {
    return [];
  }

  return data;
});

export const fetchAgentLiveTransferRequestDispositions = createAsyncThunk<
  AgentLiveTransferRequestDisposition[]
>('agents/fetchAgentLiveTransferRequestDispositions', async () => {
  const response = await instance.get(
    `/v4/agent-live-transfer/request-dispositions/`,
  );

  const data = deserializeData<AgentLiveTransferRequestDisposition[]>(
    response.data,
  );

  if (!data || !data.length) {
    return [];
  }

  return data;
});
